import { isEmpty } from 'lodash';

export const decorateSelectMultipleData = (selectValue: Array<string>) => {
  if (isEmpty(selectValue)) return [];

  return selectValue.length > 1 ? selectValue.slice().sort() : selectValue;
};
